import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	items: [],
	totalItems: 0,
	totalPrice: 0,
	loading: false,
	error: null,
};

const cartSlice = createSlice({
	name: "cart",
	initialState,
	reducers: {
		fetchCartStart(state) {
			state.loading = true;
			state.error = null;
		},
		fetchCartSuccess(state, action) {
			state.items = action.payload.items || [];
			state.totalItems = action.payload.totalItems || 0;
			state.totalPrice = action.payload.totalPrice || 0;
			state.loading = false;
		},
		fetchCartFailure(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		addToCartSuccess(state, action) {
			const updatedItem = action.payload;
			const existingIndex = state.items.findIndex(
				(item) =>
					item?.productId === updatedItem?.productId &&
					item?.variantId === updatedItem?.variantId,
			);

			if (existingIndex >= 0) {
				state.items[existingIndex] = updatedItem;
			} else {
				state.items.push(updatedItem);
			}

			// Recalculate totals
			state.totalItems = state.items.reduce(
				(sum, item) => sum + item.quantity,
				0,
			);
			state.totalPrice = state.items.reduce(
				(sum, item) => sum + item.total,
				0,
			);
		},
		removeFromCartSuccess(state, action) {
			const { productId, variantId } = action.payload;
			state.items = state.items.filter(
				(item) =>
					!(
						item.productId === productId &&
						(variantId ? item.variantId === variantId : true)
					),
			);

			// Recalculate totals
			state.totalItems = state.items.reduce(
				(sum, item) => sum + item.quantity,
				0,
			);
			state.totalPrice = state.items.reduce(
				(sum, item) => sum + item.total,
				0,
			);
		},
		clearCartSuccess(state) {
			state.items = [];
			state.totalItems = 0;
			state.totalPrice = 0;
		},
		updateCartItemQuantity(state, action) {
			const { productId, variantId, quantity } = action.payload;
			const item = state.items.find(
				(item) =>
					item.productId === productId &&
					(variantId ? item.variantId === variantId : true),
			);

			if (item) {
				item.quantity = quantity;
				item.total = item.price * quantity;

				// Recalculate totals
				state.totalItems = state.items.reduce(
					(sum, item) => sum + item.quantity,
					0,
				);
				state.totalPrice = state.items.reduce(
					(sum, item) => sum + item.total,
					0,
				);
			}
		},
	},
});

export const {
	fetchCartStart,
	fetchCartSuccess,
	fetchCartFailure,
	addToCartSuccess,
	removeFromCartSuccess,
	clearCartSuccess,
	updateCartItemQuantity,
} = cartSlice.actions;

export default cartSlice.reducer;
